import React from 'react';
import { Progress } from 'antd';
import questionsTheme from './questionsTheme';

const ProgressStats = ({ stats }) => {
    const { total, answered, correctCount, percentage, accuracy } = stats;

    if (total === 0) return null;

    return (
        <div
            className="margin-b--m padding--m"
            style={{
                backgroundColor: '#f5f5f5',
                borderRadius: '8px',
                border: `1px solid ${questionsTheme.unmarkedGray}`
            }}
        >
            <div className="flexRow flexWrap largeGap" style={{ alignItems: 'center' }}>
                {/* Completion Progress */}
                <div style={{ flex: '1 1 300px', minWidth: '200px' }}>
                    <div className="margin-b--xs" style={{ fontWeight: '600', color: questionsTheme.textDark }}>
                        Completion
                    </div>
                    <Progress
                        percent={percentage}
                        strokeColor={questionsTheme.primaryTeal}
                        railColor={questionsTheme.unmarkedGray}
                        status="active"
                        format={() => `${answered}/${total}`}
                    />
                </div>

                {/* Accuracy Progress */}
                {answered > 0 && (
                    <div style={{ flex: '1 1 300px', minWidth: '200px' }}>
                        <div className="margin-b--xs" style={{ fontWeight: '600', color: questionsTheme.textDark }}>
                            Accuracy
                        </div>
                        <Progress
                            percent={accuracy}
                            strokeColor={accuracy >= 70 ? questionsTheme.correctGreen : questionsTheme.incorrectRed}
                            railColor={questionsTheme.unmarkedGray}
                            format={() => `${correctCount}/${answered} correct`}
                        />
                    </div>
                )}

                {/* Stats Summary */}
                <div style={{ flex: '0 0 auto', display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '24px', fontWeight: 'bold', color: questionsTheme.primaryTeal }}>
                            {percentage}%
                        </div>
                        <div style={{ fontSize: '12px', color: '#666' }}>Complete</div>
                    </div>
                    {answered > 0 && (
                        <div style={{ textAlign: 'center' }}>
                            <div style={{
                                fontSize: '24px',
                                fontWeight: 'bold',
                                color: accuracy >= 70 ? questionsTheme.correctGreen : questionsTheme.incorrectRed
                            }}>
                                {accuracy}%
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>Accurate</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProgressStats;
